import { renderEntityDeleted as renderDefaultEntityDeleted } from '@core/audit/renderers/entityCrud';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { HistoryLines } from '../HistoryLines';
import {
  historySubject,
  isVestmentItemType,
  readHistoryColor,
  vestmentAction,
} from '../historyLabel';

export const renderEntityDeleted: AuditLogRenderer = (entry) => {
  if (!isVestmentItemType(entry.subjectType)) {
    return renderDefaultEntityDeleted(entry);
  }

  return (
    <HistoryLines
      title={historySubject(entry)}
      action={vestmentAction(entry.subjectType, 'Removed')}
      color={readHistoryColor(entry)}
    />
  );
};
